import menuConfig from "./MenuConfig";
import { privateAxios } from "./apiConfig";

export const syncMenuToBackend = async () => {
  try {
    const payload = menuConfig.map(({ id, name, path, category }) => ({
      featureId: id,
      name,
      path,      // ✅ matches backend DTO
      category,
    }));

    await privateAxios.post("admin/features/sync", payload);
  } catch (err) {
    console.error("Menu sync failed", err);
  }
};
